import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveChatGroup } from '../store/slices/chatHistorySlice';
import ChatNavigationService from '../services/ChatNavigationService';
import useWebSocketContext from './useWebSocketContext';
import { RootState } from '../store/store';

export const useChatNavigation = () => {
  const dispatch = useDispatch();
  const { switchToChat, isConnected } = useWebSocketContext();
  const chatNavService = ChatNavigationService.getInstance();
  const chatGroups = useSelector((state: RootState) => state.chatHistory.chatGroups);

  // Handle initial URL on component mount only if it was explicitly set
  useEffect(() => {
    const loadChatFromURL = async () => {
      const chatId = chatNavService.getChatIdFromURL();
      // Only process URL if it was explicitly set and we have chat groups loaded
      if (chatId && window.location.hash && isConnected && chatGroups.length > 0) {
        const chatExists = chatGroups.some(group => group.id === chatId);
        if (chatExists) {
          dispatch(setActiveChatGroup(chatId));
          switchToChat(chatId);
        }
      }
    };

    loadChatFromURL();
  }, [isConnected, chatGroups]);

  const navigateToChat = (chatId: string) => {
    // Update URL
    chatNavService.updateURL(chatId);
    
    // Update Redux state
    dispatch(setActiveChatGroup(chatId));
    
    // Load chat messages via WebSocket
    switchToChat(chatId);
  };

  return { navigateToChat };
};

export default useChatNavigation; 